import React, { useState, useEffect } from 'react';
import { Button, Modal, Input } from '@attentive-platform/stem-ui';

const InflateModal = ({ show, onClose, onApply, currentInflationPercentage }) => {
  const [inputValue, setInputValue] = useState('');

  // Initialize input field with current inflation percentage when modal opens
  useEffect(() => {
    if (show) {
      setInputValue(currentInflationPercentage.toString());
    }
  }, [show, currentInflationPercentage]);

  const handleApply = () => {
    if (onApply) {
      onApply(inputValue);
    }
    setInputValue('');
    onClose();
  };

  const handleClose = () => {
    setInputValue('');
    onClose();
  };

  return (
    <Modal
      show={show}
      onClose={handleClose}
      content={
        <div className='flex flex-col gap-2 m-4 w-[200px]'>
          <Input
            autoFocus
            type='number'
            label='Input value'
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
          />
          <div className='mt-4 flex justify-center gap-2'>
            <Button onClick={handleClose} color='primary' variant='outlined'>
              Cancel
            </Button>
            <Button onClick={handleApply} color='primary' variant='contained'>
              Apply
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default InflateModal;
